import { render, staticRenderFns } from "./editSpu.vue?vue&type=template&id=8554270c&scoped=true&"
import script from "./editSpu.vue?vue&type=script&lang=js&"
export * from "./editSpu.vue?vue&type=script&lang=js&"
import style0 from "./editSpu.vue?vue&type=style&index=0&id=8554270c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8554270c",
  null
  
)

export default component.exports